import { useState } from "react";
import { Theme } from "../component/navigation/ThemeDropdown";

export default function SidebarExpandIcon({ theme }: { theme: Theme }) {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <div
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={{ display: "inline-block" }}
        >
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{
                    transition: "fill 0.3s ease", // transition effect for hover
                }}
            >
                <path
                    d="M11.9993 23.9985C18.6263 23.9985 23.9985 18.6263 23.9985 11.9993C23.9985 5.37225 18.6263 0 11.9993 0C5.37225 0 0 5.37225 0 11.9993C0 18.6263 5.37225 23.9985 11.9993 23.9985Z"
                    fill={
                        theme === "light"
                            ? isHovered
                                ? "#C6D92D"
                                : "#D8D8D8"
                            : isHovered
                              ? "#C6D92D"
                              : "#7A8690"
                    }
                    style={{
                        transition: "fill 0.3s ease",
                    }}
                />
                <path
                    d="M18.2804 12.3406L7.51007 18.8441C7.24495 19.0052 6.90512 18.8133 6.90512 18.5028V5.49576C6.90512 5.18523 7.24348 4.99481 7.51007 5.15447L18.2804 11.658C18.5367 11.8132 18.5367 12.1853 18.2804 12.3406Z"
                    fill={
                        theme === "light"
                            ? isHovered
                                ? "#FFFFFF"
                                : "#606161"
                            : isHovered
                              ? "#2D3748"
                              : "#2D3748"
                    }
                    style={{
                        transition: "fill 0.3s ease",
                    }}
                />
            </svg>
        </div>
    );
}
